<script setup lang="ts">
withDefaults(defineProps<{
  label: string;
  hint?: string;
  group?: boolean;
  controlId?: string;
}>(), { hint: '', group: false, controlId: '' });
</script>

<template>
  <div v-if="group" class="vptw:block vptw:min-w-0 vptw:text-xs vptw:text-(--vs-ink-2)" role="group" :aria-label="label">
    <span class="vptw:mb-1 vptw:flex vptw:min-w-0 vptw:items-center vptw:justify-between vptw:gap-2">
      <span class="vptw:truncate vptw:font-medium">{{ label }}</span>
      <span v-if="hint" class="vptw:shrink-0 vptw:text-[10px] vptw:text-(--vs-ink-3)">{{ hint }}</span>
    </span>
    <span class="vptw:block vptw:min-w-0"><slot /></span>
  </div>
  <label v-else class="vptw:block vptw:min-w-0 vptw:text-xs vptw:text-(--vs-ink-2)" :for="controlId || undefined">
    <span class="vptw:mb-1 vptw:flex vptw:min-w-0 vptw:items-center vptw:justify-between vptw:gap-2">
      <span class="vptw:truncate vptw:font-medium">{{ label }}</span>
      <span v-if="hint" class="vptw:shrink-0 vptw:text-[10px] vptw:text-(--vs-ink-3)">{{ hint }}</span>
    </span>
    <span class="vptw:block vptw:min-w-0"><slot /></span>
  </label>
</template>
